const getHPODiseases = (state) => {
  return __IS_COMPONENTS_PORTAL__
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]?.hpo_tree
        ?.hpo[0]?.diseases
    : state?.variantResult?.hpo_tree?.hpo[0]?.diseases;
};

export { getHPODiseases };
